// A chunk from an older deploy, or a page's RSC stream cut off halfway through
// a client-side navigation, isn't a bug — a fresh load fixes it. The cut stream
// surfaces as WebKit's "Load failed" / "Error in input stream", Chrome's
// "network error", or React's own "Connection closed." when the body just ends
// (reproduced in WebKit 2026-10-16). By then the URL already points at the
// page the user tapped, so the reload lands them where they were going.
const RELOADABLE =
	/ChunkLoadError|Loading chunk .* failed|Load failed|Error in input stream|network error|Connection closed/;
// Shared by the route-level and global boundaries, so a reload that crashes
// again in the other boundary still stops instead of looping.
const RELOAD_KEY = "global-error-reloaded-at";
const RELOAD_PROBE_KEY = "global-error-storage-probe";
const RELOAD_COOLDOWN_MS = 10_000;

export function canAutoReload(error: Error) {
	if (
		typeof window === "undefined" ||
		!RELOADABLE.test(`${error.name}: ${error.message}`)
	) {
		return false;
	}
	// If the reload hits the same error, stop and show the page instead of
	// looping.
	try {
		const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
		// Old iOS private mode reads storage but throws on write; a reload we
		// can't mark would loop, so check the write works before promising one.
		sessionStorage.setItem(RELOAD_PROBE_KEY, "1");
		return Date.now() - last >= RELOAD_COOLDOWN_MS;
	} catch {
		// No storage means no loop guard, so don't risk it.
		return false;
	}
}

export function markAutoReload() {
	sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
}
